import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericCrudAddComponent } from '../../../../../libs/components/generic-crud/generic-crud-add.component';
import { TId, WorkProcedure } from '../../../../../models';

@Component({
    selector: 'app-work-procedures-add',
    templateUrl: './work-procedures-add.component.html',
    styleUrl: './work-procedures-add.component.sass',
    standalone: false
})
export class WorkProceduresAddComponent extends GenericCrudAddComponent<WorkProcedure> {
  @Input() documentTypeId?: TId;

  constructor() {
    super();
    this.resource = this.api.resources.product.workProcedures;
  }

  initFormGroup(): FormGroup {
    const group = this.fb.group({
      name: [''],
      code: [''],
      companyId: [this.api.auth.userValue?.lastCompanyId],
      documentTypeId: [this.documentTypeId],
    });
    return group;
  }

}
